










































































































































































import dayjs from 'dayjs'
import { Component, Vue, Watch } from 'vue-property-decorator'
import controller from '@/app/ui/controllers/ProgrammaticVoucherController'
import routeController from '@/app/ui/controllers/RouteController'
import { Utils, EventBus, EventBusConstants } from '@/app/infrastructures/misc'
import Badge from '@/app/ui/components/Badge/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import EditIcon from '@/app/ui/assets/edit_icon.vue'
import { ProgrammaticVoucher } from '@/domain/entities/ProgrammaticVoucher'

@Component({
  components: {
    Badge,
    Button,
    Modal,
    EditIcon,
    LoadingOverlay,
  },
})
export default class ProgrammaticVoucherDetail extends Vue {
  isGuest = Utils.isGuest()
  controller = controller
  confirmationModal = false
  successModal = false

  created(): void {
    controller.getTriggers()
    controller.getProgrammaticVoucherDetail(this.$route.params.id)

    EventBus.$on(EventBusConstants.DELETE_VOUCHER_SUCCESS, () => {
      this.successModal = true
    })
  }

  @Watch('voucherDetail')
  onVoucherDetailChanged(val: ProgrammaticVoucher): void {
    if (val.voucherTarget === 'SPECIFIC_ORIGIN') {
      routeController.getCityList()
    }
  }

  get isCancelled(): boolean {
    return this.voucherDetail.status === 'CANCELLED'
  }

  get voucherDetail(): ProgrammaticVoucher {
    return controller.voucherDetail
  }

  get userType(): string | undefined  {
    return controller.constants.targetOptions.find(
      (item) => item.value === this.voucherDetail.voucherTarget
    )?.label
  }

  get triggerType(): string | undefined  {
    return controller.triggerData.find(
      (item) => item.value === this.voucherDetail.voucherTrigger
    )?.label
  }

  get purposeParent(): string | undefined  {
    return controller.constants.purposeOptions.find(
      (item) => item.value === this.voucherDetail.voucherPurposeParent
    )?.label
  }

  get purposeChild(): string | undefined {
    return controller.constants.tncOptions.find(
      (item) => item.value === this.voucherDetail.voucherPurposeChild
    )?.label
  }

  get selectedUserFile(): string {
    return this.voucherDetail.selectedUserUrl?.split('/').slice(-1)[0] || '-'
  }

  get osInfo(): string {
    return `${this.voucherDetail.os} Apps ${this.voucherDetail.osValidation} v${this.voucherDetail.osValidationVersion}`
  }

  get isRedeemToPoint(): boolean {
    return (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[0].value
    )
  }

  get isDiscByAmount(): boolean {
    return (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[1].value
    )
  }

  get isDiscByPercent(): boolean {
    return (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[2].value
    )
  }

  get isCashback(): boolean {
    return (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[3].value
    )
  }

  get listOfCities(): string {
    return routeController.cityData
      .filter((item) =>
        this.voucherDetail.routeIds?.includes(item.value.toString())
      )
      .map((item) => item.label)
      .join(', ')
  }

  get statusBadgeType(): string {
    if (
      this.voucherDetail?.status?.toLowerCase() === 'expired'
    ) {
      return 'error'
    } else if (
      this.voucherDetail?.status?.toLowerCase() === 'cancelled'
    ) {
      return 'cancelled'
    } else if (
      this.voucherDetail?.status?.toLowerCase() === 'active' ||
      this.voucherDetail?.status?.toLowerCase() === 'published'
    ) {
      return 'success'
    } else {
      return 'warning'
    }
  }

  get minimumTransaction(): string | number  {
    if (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[1].value
    ) {
      return this.formatCurrency(this.voucherDetail.discountMinimum || 0)
    } else if (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[2].value
    ) {
      return this.formatCurrency(
        this.voucherDetail.discountPercentageMinimum || 0
      )
    } else if (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[3].value
    ) {
      return this.formatCurrency(
        this.voucherDetail.cashbackPercentageMinimum || 0
      )
    } else {
      return '-'
    }
  }

  get maximumTransaction(): string | number {
    if (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[2].value
    ) {
      return this.formatCurrency(
        this.voucherDetail.discountPercentageMaximum || 0
      )
    } else if (
      this.voucherDetail.voucherPurposeChild ===
      controller.constants.tncOptions[3].value
    ) {
      return this.formatCurrency(
        this.voucherDetail.cashbackPercentageMaximum || 0
      )
    } else {
      return '-'
    }
  }

  private formatCurrency(number: number): string | number {
    return `Rp${Utils.currencyDigit(number || 0)}`
  }

  private cancelVoucher(): void {
    controller.deleteVoucher({ voucherId: this.$route.params.id })
    this.confirmationModal = false
  }

  private onCloseSuccessModal(): void {
    controller.getProgrammaticVoucherDetail(this.$route.params.id)
    this.successModal = false
  }

  private formatDate(date: string, format = 'DD MMMM YYYY, HH:mm [WIB]'): string {
    return date ? dayjs(date).format(format) : '-'
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.DELETE_VOUCHER_SUCCESS)
  }
}
